import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext.js";
import {
  SIGN_IN_REDIRECT_IN_PROGRESS_KEY,
  setSignInDestination,
  takeSignInDestination,
} from "./firebaseSignIn.js";

/**
 * Whether this page load is the return from a redirect sign-in.
 * @returns {boolean}
 */
const isResumingRedirectSignIn = () => {
  try {
    return Boolean(sessionStorage.getItem(SIGN_IN_REDIRECT_IN_PROGRESS_KEY));
  } catch {
    return false;
  }
};

/**
 * Lands a redirect sign-in on the destination its dialog remembered
 * (setSignInDestination). The redirect reloads the app and drops the dialog, so
 * this app-level listener is the one place that follows it, once.
 */
export const RedirectSignInForward = () => {
  const { user, isCheckingRedirect } = useContext(AuthContext);
  const navigate = useNavigate();
  const [resuming] = useState(isResumingRedirectSignIn);
  const doneRef = useRef(!resuming);

  useEffect(() => {
    // A destination only survives a redirect; on any other load it's left over.
    if (!resuming) setSignInDestination(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (doneRef.current) return;
    if (user) {
      doneRef.current = true;
      const destination = takeSignInDestination();
      if (destination) navigate(destination.route, { state: destination.state });
    } else if (!isCheckingRedirect) {
      // The redirect ended without a sign-in (cancelled or failed).
      doneRef.current = true;
      setSignInDestination(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isCheckingRedirect]);

  return null;
};
